import type { AffiliateListItem, Readiness } from '../api/affilmaster';

const nf = new Intl.NumberFormat('cs-CZ');

export function fmtN(v: number | null | undefined): string {
  return nf.format(Number(v ?? 0));
}

// Affilmaster DWH values are EUR (PaP default). Currency conversion (CNB) is a
// later phase, keep it explicit, do not silently relabel.
export function fmtEur(v: number | null | undefined): string {
  return `${Number(v ?? 0).toLocaleString('cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €`;
}

export function affiliateName(a: Pick<AffiliateListItem, 'company_name' | 'display_name' | 'pap_affiliate_id'>): string {
  return (a.company_name?.trim() || a.display_name?.trim() || a.pap_affiliate_id) ?? '-';
}

export function summarizeNotReady(f: Readiness): string {
  if (f.problems && f.problems.length > 0) return f.problems.join(' · ');
  return 'Data Affilmaster nejsou aktuální (sync zatím neproběhl).';
}

const MESICE = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'];

export function mesicLabel(ym: string): string {
  const [y, m] = ym.split('-');
  const idx = Number(m) - 1;
  return `${MESICE[idx] ?? m} ${y}`;
}

export function fmtDen(iso: string | null): string {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${Number(d)}. ${Number(m)}. ${y}`;
}

export function fmtCastka(v: number | null, currency: string | null): string {
  if (v == null) return '—';
  return `${v.toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency ?? ''}`.trim();
}
